const MuiCssBaseline = {
  styleOverrides: `
    @font-face {
      font-family: "effra";
      src: url("https://use.typekit.net/af/5c84c3/00000000000000000001787b/27/l?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=n4&v=3") format("woff2"),
           url("https://use.typekit.net/af/5c84c3/00000000000000000001787b/27/d?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=n4&v=3") format("woff"),
           url("https://use.typekit.net/af/5c84c3/00000000000000000001787b/27/a?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=n4&v=3") format("opentype");
      font-display: auto;
      font-style: normal;
      font-weight: 400;
      font-stretch: normal;
    }

    @font-face {
      font-family: "effra";
      src: url("https://use.typekit.net/af/32bae8/00000000000000000001787c/27/l?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=i4&v=3") format("woff2"),
           url("https://use.typekit.net/af/32bae8/00000000000000000001787c/27/d?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=i4&v=3") format("woff"),
           url("https://use.typekit.net/af/32bae8/00000000000000000001787c/27/a?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=i4&v=3") format("opentype");
      font-display: auto;
      font-style: italic;
      font-weight: 400;
      font-stretch: normal;
    }

    @font-face {
      font-family: "effra";
      src: url("https://use.typekit.net/af/946b62/00000000000000000001787f/27/l?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=n7&v=3") format("woff2"),
           url("https://use.typekit.net/af/946b62/00000000000000000001787f/27/d?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=n7&v=3") format("woff"),
           url("https://use.typekit.net/af/946b62/00000000000000000001787f/27/a?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=n7&v=3") format("opentype");
      font-display: auto;
      font-style: normal;
      font-weight: 700;
      font-stretch: normal;
    }

    @font-face {
      font-family: "effra";
      src: url("https://use.typekit.net/af/64b320/000000000000000000017880/27/l?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=i7&v=3") format("woff2"),
           url("https://use.typekit.net/af/64b320/000000000000000000017880/27/d?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=i7&v=3") format("woff"),
           url("https://use.typekit.net/af/64b320/000000000000000000017880/27/a?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=i7&v=3") format("opentype");
      font-display: auto;
      font-style: italic;
      font-weight: 700;
      font-stretch: normal;
    }

    @font-face {
      font-family: "effra";
      src: url("https://use.typekit.net/af/d82207/000000000000000000017879/27/l?subset_id=2&fvd=n3&v=3") format("woff2"),
           url("https://use.typekit.net/af/d82207/000000000000000000017879/27/d?subset_id=2&fvd=n3&v=3") format("woff"),
           url("https://use.typekit.net/af/d82207/000000000000000000017879/27/a?subset_id=2&fvd=n3&v=3") format("opentype");
      font-display: auto;
      font-style: normal;
      font-weight: 300;
      font-stretch: normal;
    }

    @font-face {
      font-family: "effra";
      src: url("https://use.typekit.net/af/dc0f28/00000000000000000001787a/27/l?subset_id=2&fvd=i3&v=3") format("woff2"),
           url("https://use.typekit.net/af/dc0f28/00000000000000000001787a/27/d?subset_id=2&fvd=i3&v=3") format("woff"),
           url("https://use.typekit.net/af/dc0f28/00000000000000000001787a/27/a?subset_id=2&fvd=i3&v=3") format("opentype");
      font-display: auto;
      font-style: italic;
      font-weight: 300;
      font-stretch: normal;
    }

    @font-face {
      font-family: "effra";
      src: url("https://use.typekit.net/af/5ea570/00000000000000000001787d/27/l?subset_id=2&fvd=n5&v=3") format("woff2"),
           url("https://use.typekit.net/af/5ea570/00000000000000000001787d/27/d?subset_id=2&fvd=n5&v=3") format("woff"),
           url("https://use.typekit.net/af/5ea570/00000000000000000001787d/27/a?subset_id=2&fvd=n5&v=3") format("opentype");
      font-display: auto;
      font-style: normal;
      font-weight: 500;
      font-stretch: normal;
    }

    @font-face {
      font-family: "effra";
      src: url("https://use.typekit.net/af/9ead62/00000000000000000001787e/27/l?subset_id=2&fvd=i5&v=3") format("woff2"),
           url("https://use.typekit.net/af/9ead62/00000000000000000001787e/27/d?subset_id=2&fvd=i5&v=3") format("woff"),
           url("https://use.typekit.net/af/9ead62/00000000000000000001787e/27/a?subset_id=2&fvd=i5&v=3") format("opentype");
      font-display: auto;
      font-style: italic;
      font-weight: 500;
      font-stretch: normal;
    }

    @font-face {
      font-family: "effra";
      src: url("https://use.typekit.net/af/d3769f/000000000000000000017881/27/l?subset_id=2&fvd=n9&v=3") format("woff2"),
           url("https://use.typekit.net/af/d3769f/000000000000000000017881/27/d?subset_id=2&fvd=n9&v=3") format("woff"),
           url("https://use.typekit.net/af/d3769f/000000000000000000017881/27/a?subset_id=2&fvd=n9&v=3") format("opentype");
      font-display: auto;
      font-style: normal;
      font-weight: 900;
      font-stretch: normal;
    }

    @font-face {
      font-family: "effra";
      src: url("https://use.typekit.net/af/06ea21/000000000000000000017882/27/l?subset_id=2&fvd=i9&v=3") format("woff2"),
           url("https://use.typekit.net/af/06ea21/000000000000000000017882/27/d?subset_id=2&fvd=i9&v=3") format("woff"),
           url("https://use.typekit.net/af/06ea21/000000000000000000017882/27/a?subset_id=2&fvd=i9&v=3") format("opentype");
      font-display: auto;
      font-style: italic;
      font-weight: 900;
      font-stretch: normal;
    }

    .tk-effra { font-family: "effra", sans-serif; }
    @font-face {
      font-family: "utopia-std";
      src: url("https://use.typekit.net/af/9ff5df/0000000000000000000131a3/27/l?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=n4&v=3") format("woff2"),
           url("https://use.typekit.net/af/9ff5df/0000000000000000000131a3/27/d?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=n4&v=3") format("woff"),
           url("https://use.typekit.net/af/9ff5df/0000000000000000000131a3/27/a?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=n4&v=3") format("opentype");
      font-display: auto;
      font-style: normal;
      font-weight: 400;
      font-stretch: normal;
    }

    @font-face {
      font-family: "utopia-std";
      src: url("https://use.typekit.net/af/6ebf8d/0000000000000000000131a0/27/l?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=n7&v=3") format("woff2"),
           url("https://use.typekit.net/af/6ebf8d/0000000000000000000131a0/27/d?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=n7&v=3") format("woff"),
           url("https://use.typekit.net/af/6ebf8d/0000000000000000000131a0/27/a?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=n7&v=3") format("opentype");
      font-display: auto;
      font-style: normal;
      font-weight: 700;
      font-stretch: normal;
    }

    @font-face {
      font-family: "utopia-std";
      src: url("https://use.typekit.net/af/1d830d/0000000000000000000131a4/27/l?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=n6&v=3") format("woff2"),
           url("https://use.typekit.net/af/1d830d/0000000000000000000131a4/27/d?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=n6&v=3") format("woff"),
           url("https://use.typekit.net/af/1d830d/0000000000000000000131a4/27/a?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=n6&v=3") format("opentype");
      font-display: auto;
      font-style: normal;
      font-weight: 600;
      font-stretch: normal;
    }

    .tk-utopia-std { font-family: "utopia-std", serif; }
  `
};
export default MuiCssBaseline;